import React, { type ReactNode } from "react";
import styles from "./ErrorText.module.scss";
import { combineClasses } from "@/lib/utils";

interface ErrorTextProps {
  children: ReactNode;
  className?: string;
}
const ErrorText: React.FC<ErrorTextProps> = ({ children, className }) => {
  return (
    <p className={combineClasses(styles.validation_text, className)}>
      {children}
    </p>
  );
};

export default ErrorText;
